// Olympe
import { getLogger } from '@olympeio/core';

/**
 * Parse a json string without throwing an exception
 * @param {string|!Object} json 
 * @return {!Array}
 */
export function fromJson(json) {
    try {
        return typeof json === 'string'
            ? [JSON.parse(json), null]
            : [json ?? {}, null];
    }
    catch(err) {
        return [{}, err];
    }
}

/**
 * Warn message with a default format
 * @param {string} message 
 */
export function warn(message) {
    getLogger('ReactGrid').warn(`ReactGrid: ${message}`);
}

/**
 * Error message with a default format
 * @param {string} message 
 */
export function error(message) {
    getLogger('ReactGrid').error(`ReactGrid: ${message}`);
}

/**
 * Make a jsonpath-plus path readable
 * @param {string} path
 * @return {string} 
 */
export function trimPath(path) {
    if(path.startsWith('$') || path.startsWith('.')) {
        return trimPath(path.substring(1));
    }
    if(path.startsWith('[')) {
        return trimPath(path.substring(path.indexOf(']') + 1));
    }
    return path;
}

/**
 * Test for email format
 * @param {string} text
 * @return {boolean}
 */
export function validateEmail(text) {
    return emailRegex.test(text);
}

// Email regex (https://emailregex.com/)
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Reorders elements in an object by moving specific elements to a new position.
 *
 * @param {Array} values - The original array to reorder.
 * @param {number[]} ids - An array of indices representing the elements to move.
 * @param {number} to - The target index where the selected elements should be moved.
 * @return {Object} - A new object with the specified elements reordered.
 */
export function reorderObject(values, ids, to) {
    const reorderedValues = [...values];

    // Get elements to move based on the ids
    const elementsToMove = ids.map(index => reorderedValues[index]);
    ids.sort((a, b) => b - a).forEach(index => {
        reorderedValues.splice(index, 1);
    });

    // Adjust the target id based on moving forward or backward
    const adjustedTargetId = to >= Math.min(...ids) ? to - elementsToMove.length + 1 : to;

    // Insert the elements in target id
    if (elementsToMove.length > 0) {
        reorderedValues.splice(adjustedTargetId, 0, ...elementsToMove);
    }

    return reorderedValues;
}

